import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirestoreRoomStateOutput } from '../firestore/RoomStateOutput/schema'
import { empty } from '../firestore/RoomStateOutput/schema'

export class RoomStateOutput extends ObservableModelWithDecorators<FirestoreRoomStateOutput> {
  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateOutput>
  ) {
    super(repository, doc)
  }

  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }
}
